export default function indicatorsContainerStyle() {
  return (styles) => ({
    ...styles,
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translateY(-50%)'
  });
}
